/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import Filter, { FilterableProps } from '../Filter'
import useTransactionCategoryOptions from '../transaction/useTransactionCategoryOptions'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'
import { useIntl } from 'react-intl'
import { Checkbox, Radio } from '@mantine/core'

function TransactionCategoryFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const options = useTransactionCategoryOptions()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        id="transaction_category_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="category"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      {options.map((option) => (
        <Checkbox
          checked={array.includes(option.value)}
          key={option.value}
          label={option.label}
          name="category"
          onChange={handleChange}
          value={option.value}
        />
      ))}
    </Filter>
  )
}

export default TransactionCategoryFilter
